// Generated by purs version 0.14.3
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Data_Unfoldable1 = require("../Data.Unfoldable1/index.js");
var Network_Ethereum_Web3_Solidity_Size = require("../Network.Ethereum.Web3.Solidity.Size/index.js");
var Vector = function (x) {
    return x;
};
var vectorLength = function (dictKnownSize) {
    return function (v) {
        return Data_Array.length(v);
    };
};
var vCons = function (dictInc) {
    return function (a) {
        return function (v) {
            return Data_Array.cons(a)(v);
        };
    };
};
var unfoldableVector = Data_Unfoldable.unfoldableArray;
var unfoldable1Vector = Data_Unfoldable1.unfoldable1Array;
var unVector = function (v) {
    return v;
};
var traversableVector = Data_Traversable.traversableArray;
var toVector = function (dictKnownSize) {
    return function (v) {
        return function (as) {
            var $13 = Network_Ethereum_Web3_Solidity_Size.sizeVal(dictKnownSize)(Network_Ethereum_Web3_Solidity_Size.DLProxy.value) !== Data_Array.length(as);
            if ($13) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(as);
        };
    };
};
var showVector = function (dictShow) {
    return Data_Show.showArray(dictShow);
};
var nilVector = Data_Monoid.mempty(Data_Monoid.monoidArray);
var functorVector = Data_Functor.functorArray;
var foldableVector = Data_Foldable.foldableArray;
var eqVector = function (dictEq) {
    return Data_Eq.eqArray(dictEq);
};
module.exports = {
    unVector: unVector,
    nilVector: nilVector,
    vCons: vCons,
    vectorLength: vectorLength,
    toVector: toVector,
    showVector: showVector,
    eqVector: eqVector,
    functorVector: functorVector,
    unfoldable1Vector: unfoldable1Vector,
    unfoldableVector: unfoldableVector,
    foldableVector: foldableVector,
    traversableVector: traversableVector
};
